import { Page } from '@/core/architecture'

import { ConsoleQuantityManagementsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleQuantityManagements Page
 * Implemented as a practical sample.
 */
export const ConsoleQuantityManagements: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleQuantityManagementsTemplate state={state} {...actions} />
}
